import _extends from '@babel/runtime/helpers/extends';
import _ArrowIosDownward from '@lyearn/icons/dist/cjs/web/ArrowIosDownward';
import _Close from '@lyearn/icons/dist/cjs/web/Close';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { forwardRef, useRef, useMemo } from 'react';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import useAutocomplete from '@mui/material/useAutocomplete';
import c from 'classnames';
import isEqual from 'lodash/isEqual';
import Box from '../../Box/Box.js';
import LinkButton from '../../LinkButton/LinkButton.js';
import Popper from '../../Popper/index.js';
import Stack from '../../Stack/Stack.js';
import { renderNoOptions, renderGroupedOptions } from './renderers.js';
import { getAutocompleteClasses } from './styles.js';

var _excluded = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "error", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionLabel", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "isOptionEqualToValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "placeholder", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"];
// Reference: https://github.com/mui-org/material-ui/blob/master/packages/mui-material/src/Autocomplete/Autocomplete.js
var BaseAutocomplete = function BaseAutocomplete(props, ref) {
  props.autoComplete;
    props.autoHighlight;
    props.autoSelect;
    props.blurOnSelect;
    var ChipProps = props.ChipProps,
    classesProp = props.classes,
    className = props.className,
    _props$clearIcon = props.clearIcon,
    clearIcon = _props$clearIcon === void 0 ? /*#__PURE__*/React__default.createElement(_Close, null) : _props$clearIcon;
    props.clearOnBlur;
    props.clearOnEscape;
    var _props$clearText = props.clearText,
    clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
    _props$closeText = props.closeText,
    closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp;
    props.defaultValue;
    var _props$disableClearab = props.disableClearable,
    disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab;
    props.disableCloseOnSelect;
    var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled;
    props.disabledItemsFocusable;
    props.disableListWrap;
    var _props$disablePortal = props.disablePortal,
    disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
    error = props.error;
    props.filterOptions;
    props.filterSelectedOptions;
    var _props$forcePopupIcon = props.forcePopupIcon,
    forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
    _props$freeSolo = props.freeSolo,
    freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo;
    props.fullWidth;
    var _props$getLimitTagsTe = props.getLimitTagsText,
    getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
      return "+" + more;
    } : _props$getLimitTagsTe,
    _props$getOptionLabel = props.getOptionLabel,
    getOptionLabel = _props$getOptionLabel === void 0 ? function (option) {
      var _option$label;
      return (_option$label = option.label) != null ? _option$label : option;
    } : _props$getOptionLabel,
    groupBy = props.groupBy;
    props.handleHomeEndKeys;
    props.id;
    props.includeInputInList;
    props.inputValue;
    props.isOptionEqualToValue;
    var _props$limitTags = props.limitTags,
    limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
    _props$ListboxCompone = props.ListboxComponent,
    ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
    ListboxProps = props.ListboxProps,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    _props$loadingText = props.loadingText,
    loadingText = _props$loadingText === void 0 ? 'Loading' : _props$loadingText,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    _props$noOptionsText = props.noOptionsText,
    noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText;
    props.onChange;
    props.onClose;
    props.onHighlightChange;
    props.onInputChange;
    props.onOpen;
    props.open;
    props.openOnFocus;
    var _props$openText = props.openText,
    openText = _props$openText === void 0 ? 'Open' : _props$openText;
    props.options;
    var _props$PaperComponent = props.PaperComponent,
    PaperComponent = _props$PaperComponent === void 0 ? Paper : _props$PaperComponent,
    placeholder = props.placeholder,
    _props$PopperComponen = props.PopperComponent,
    PopperComponent = _props$PopperComponen === void 0 ? Popper : _props$PopperComponen,
    _props$popupIcon = props.popupIcon,
    popupIcon = _props$popupIcon === void 0 ? /*#__PURE__*/React__default.createElement(_ArrowIosDownward, null) : _props$popupIcon,
    renderGroup = props.renderGroup,
    renderInput = props.renderInput,
    _props$renderOption = props.renderOption,
    renderOption = _props$renderOption === void 0 ? getOptionLabel : _props$renderOption,
    renderTags = props.renderTags;
    props.selectOnFocus;
    var _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    valueProp = props.value,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var previousValueRef = useRef(valueProp);
  // useAutocomplete resets the searchText when reference of value changes
  // so sending the previous reference if the value is not changed
  var autocompleteValue = useMemo(function () {
    if (!isEqual(previousValueRef.current, valueProp)) {
      previousValueRef.current = valueProp;
    }
    return previousValueRef.current;
  }, [valueProp]);
  var _useAutocomplete = useAutocomplete(_extends({}, props, {
      getOptionLabel: getOptionLabel,
      value: autocompleteValue
    })),
    anchorEl = _useAutocomplete.anchorEl,
    dirty = _useAutocomplete.dirty,
    focused = _useAutocomplete.focused,
    getClearProps = _useAutocomplete.getClearProps,
    getInputProps = _useAutocomplete.getInputProps,
    getListboxProps = _useAutocomplete.getListboxProps,
    getOptionProps = _useAutocomplete.getOptionProps,
    getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
    getRootProps = _useAutocomplete.getRootProps,
    getTagProps = _useAutocomplete.getTagProps,
    groupedOptions = _useAutocomplete.groupedOptions,
    id = _useAutocomplete.id,
    inputValue = _useAutocomplete.inputValue,
    popupOpen = _useAutocomplete.popupOpen,
    setAnchorEl = _useAutocomplete.setAnchorEl,
    value = _useAutocomplete.value;
  var hasClearIcon = !disableClearable && !disabled && dirty;
  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  var classes = useMemo(function () {
    return getAutocompleteClasses(size, classesProp);
  }, [classesProp, size]);
  var getInputStartAdornment = function getInputStartAdornment() {
    var startAdornment;
    if (multiple && Array.isArray(value) && value.length > 0) {
      var getAdaptedTagProps = function getAdaptedTagProps(params) {
        return _extends({
          className: classes.tag,
          disabled: disabled
        }, getTagProps(params));
      };
      if (renderTags) {
        startAdornment = renderTags(value, getAdaptedTagProps);
      } else {
        startAdornment = value.map(function (option, index) {
          return /*#__PURE__*/React__default.createElement(Chip, _extends({
            label: getOptionLabel(option)
          }, getAdaptedTagProps({
            index: index
          }), ChipProps));
        });
      }
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
      var more = startAdornment.length - limitTags;
      if (!focused && more > 0) {
        startAdornment = startAdornment.splice(0, limitTags);
        startAdornment.push( /*#__PURE__*/React__default.createElement(Box, {
          key: startAdornment.length,
          className: classes == null ? void 0 : classes.tag,
          component: "span"
        }, getLimitTagsText(more)));
      }
    }
    return startAdornment;
  };
  var getInputEndAdornment = function getInputEndAdornment() {
    var _componentsProps$clea;
    return /*#__PURE__*/React__default.createElement(Stack, {
      className: classes == null ? void 0 : classes.endAdornment,
      gapX: 2
    }, hasClearIcon ? /*#__PURE__*/React__default.createElement(LinkButton, _extends({
      "aria-label": clearText,
      title: clearText
    }, getClearProps(), componentsProps == null ? void 0 : componentsProps.clearIndicator, {
      className: c(classes == null ? void 0 : classes.clearIndicator, componentsProps == null ? void 0 : (_componentsProps$clea = componentsProps.clearIndicator) == null ? void 0 : _componentsProps$clea.className)
    }), clearIcon) : null, hasPopupIcon ? /*#__PURE__*/React__default.createElement(LinkButton, _extends({}, getPopupIndicatorProps(), {
      "aria-label": popupOpen ? closeText : openText,
      className: c(classes == null ? void 0 : classes.popupIndicator, popupOpen && (classes == null ? void 0 : classes.popupIndicatorOpen)),
      disabled: disabled
    }), popupIcon) : null);
  };
  var showLoading = loading && groupedOptions.length === 0;
  var showNoOptions = groupedOptions.length === 0 && !freeSolo && !loading;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: ref,
    className: c(classes == null ? void 0 : classes.root, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon, className)
  }, getRootProps(rest)), renderInput({
    className: classes == null ? void 0 : classes.inputRoot,
    disabled: disabled,
    endAdornment: getInputEndAdornment(),
    error: error,
    fullWidth: true,
    id: id,
    inputProps: _extends({
      className: classes == null ? void 0 : classes.input,
      disabled: disabled
    }, getInputProps()),
    placeholder: placeholder,
    // @ts-ignore
    ref: setAnchorEl,
    size: size,
    startAdornment: getInputStartAdornment()
  })), popupOpen && anchorEl ? /*#__PURE__*/React__default.createElement(PopperComponent, {
    open: true,
    anchorEl: anchorEl,
    className: classes == null ? void 0 : classes.popper,
    disablePortal: disablePortal,
    role: "presentation",
    style: {
      width: anchorEl ? anchorEl.clientWidth : 0
    }
  }, /*#__PURE__*/React__default.createElement(PaperComponent, {
    className: classes == null ? void 0 : classes.paper
  }, showLoading ? /*#__PURE__*/React__default.createElement(Box, {
    className: classes == null ? void 0 : classes.loading
  }, loadingText) : null, showNoOptions ? renderNoOptions({
    classes: classes,
    noOptionsText: noOptionsText
  }) : null, groupedOptions.length > 0 ?
  /*#__PURE__*/
  // @ts-ignore
  React__default.createElement(ListboxComponent, _extends({
    className: classes == null ? void 0 : classes.listbox
  }, ListboxProps, getListboxProps()), renderGroupedOptions({
    classes: classes,
    getOptionProps: getOptionProps,
    groupBy: groupBy,
    groupedOptions: groupedOptions,
    inputValue: inputValue,
    renderGroup: renderGroup,
    renderOption: renderOption
  })) : null)) : null);
};
var BaseAutocomplete$1 = /*#__PURE__*/forwardRef(BaseAutocomplete);

export { BaseAutocomplete$1 as default };
//# sourceMappingURL=index.js.map
